module.exports = __webpack_public_path__ + "images/609075743f6231b6db0a73b58f95a629.png";